"use client";

import { Tooltip } from "@/components/ui/primitives/tooltip";
import { ANALYSIS_TYPE_COLORS } from "@/lib/constants/analysis";
import { cn } from "@/lib/utils/general-utils";
import type { ComponentType, SVGProps } from "react";

export type AnalysisColorClasses =
  (typeof ANALYSIS_TYPE_COLORS)[keyof typeof ANALYSIS_TYPE_COLORS];

export interface AnalysisTypeCountChipProps {
  readonly label: string;
  readonly Icon: ComponentType<SVGProps<SVGSVGElement>>;
  readonly colorClasses: AnalysisColorClasses;
  readonly count: number;
}

export function AnalysisTypeCountChip({
  label,
  Icon,
  colorClasses,
  count,
}: AnalysisTypeCountChipProps) {
  const description =
    count === 1 ? `${label} · 1 analysis` : `${label} · ${count} analyses`;

  return (
    <Tooltip content={description} side="top">
      <span
        role="img"
        aria-label={description}
        className={cn(
          "relative inline-flex size-7 shrink-0 items-center justify-center rounded-md border shadow-sm",
          colorClasses.bg,
          colorClasses.border,
        )}
      >
        <Icon className={cn("size-3.5", colorClasses.text)} aria-hidden />
        <span
          className={cn(
            "absolute -top-1 -right-1 flex h-3.5 min-w-3.5 items-center justify-center rounded-full px-0.5",
            "text-[9px] font-semibold tabular-nums leading-none",
            colorClasses.iconBg,
            colorClasses.text,
            "ring-1 ring-white",
          )}
        >
          {count}
        </span>
      </span>
    </Tooltip>
  );
}
